import React from 'react';

import { CrmProjectsPage } from '../CRM';
import ManagerPage from '../../styles/templates/ManagerPage';
import { USER_ROLES } from '../../constants/roles';

const ManagerProjectsPage: React.FC = () => (
  <ManagerPage>
    <CrmProjectsPage userRole={USER_ROLES.MANAGER} />
  </ManagerPage>
);

export default ManagerProjectsPage;
